module.exports = __webpack_public_path__ + "images/videoCaseStudy-urbanPartnershipBank-results-photo-01.jpg?h=0fa0d7f4f28d8ece96864f9a8f56e7de";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-results-photo-01.jpg
// module id = 2126
// module chunks = 12 15